<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon"><i class="pi pi-wallet"></i></div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة طريقة دفع</h1>
        <p class="form-page-header__subtitle">أضف وسيلة دفع جديدة يمكن للطلاب استخدامها عند الاشتراك</p>
      </div>
    </div>
    <PaymentMethodForm />
  </div>
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import PaymentMethodForm from './PaymentMethodForm.vue';

export default {
  name: 'PaymentMethodCreate',
  components: { Breadcrumb, PaymentMethodForm },
  data() {
    return {
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'طرق الدفع', path: '/payment-methods' },
        { name: 'إضافة', path: '/payment-methods/create' },
      ],
    };
  },
};
</script>
